import React from 'react';
import classnames from 'classnames';

import './loadingAnimation.scss';

interface Props {
  className?: string;
}

const LoadingAnimation: React.FC<Props> = (props: Props) => {
  const wrapperClasses = classnames(
    'loading-animation-component',
    props.className
  );

  return (
    <span className={wrapperClasses}>
      <div className="loading-animation-component__spinner">
        <div className="loading-animation-component__spinner__ball" />
        <div className="loading-animation-component__spinner__ball" />
        <div className="loading-animation-component__spinner__ball" />
      </div>
    </span>
  );
};

export default LoadingAnimation;
